import { useCallback, useState } from "react"

// Su che campo si disegnano gli schemi: cemento, terra battuta o erba. È
// solo una pelle: lo schema salva dove stanno i pezzi, non il colore del
// campo, e cambiare superficie ridipinge tutti gli schemi senza toccarne
// uno. Come il tema, vale per questo telefono.
//
// Il colore lo fa il CSS (`.schema-surface-*` in theme.css, che cambia
// `--c-schema-court`, `--c-schema-inside` e `--c-schema-grass`): qui si
// mette la classe su body, e ogni disegno, l'editor e la voce aperta la
// seguono da soli.

export const SCHEMA_SURFACES = [
	{ id: "hard", label: "Cemento", on: "sul cemento" },
	{ id: "clay", label: "Terra battuta", on: "sulla terra battuta" },
	{ id: "grass", label: "Erba", on: "sull'erba" },
]

const IDS = SCHEMA_SURFACES.map(surface => surface.id)

// il cemento è quello che gli schemi hanno sempre avuto
export const DEFAULT_SCHEMA_SURFACE = "hard"

const STORAGE_KEY = "incampo.schemaSurface"

export const schemaSurfaceClass = surface => `schema-surface-${surface}`

export const readSchemaSurface = () => {
	try {
		const stored = window.localStorage.getItem(STORAGE_KEY)
		return IDS.includes(stored) ? stored : DEFAULT_SCHEMA_SURFACE
	} catch {
		return DEFAULT_SCHEMA_SURFACE
	}
}

export const applySchemaSurface = surface => {
	for (const id of IDS) document.body.classList.toggle(schemaSurfaceClass(id), id === surface)
}

export function useSchemaSurface() {
	const [surface, setSurface] = useState(readSchemaSurface)

	const changeSurface = useCallback(next => {
		if (!IDS.includes(next)) return
		setSurface(next)
		applySchemaSurface(next)
		try {
			window.localStorage.setItem(STORAGE_KEY, next)
		} catch {
			// vale per questa volta: meglio che un errore per un colore
		}
	}, [])

	return [surface, changeSurface]
}
